import http from '@/http';

export const getSettings = async () => {
    return await http.get('settings');
}

export const updateSettings = async (payload) => {
    return await http.post('settings', payload);
}